/**
 * @packageDocumentation
 * @module f1/string
 */

import { t_path } from '../types';

const alternateNotation = /\.|\[|\]/g;
const removeErrantLastSlash = /\/$/g;
const duplicateBrackets = /\/\//g;
const emptyBoxIsDash = /\[\]/g;

/**
 * support . notation to /
 * support [] notation to /
 */

export interface Path {
  /**
   * If you use a lens, we support JSON Pointer notation. If you want to support a broader
   * range of permutations for describing references, then you can normalize
   * the reference.
   *
   * Path reference styles:
   * - bracket, [a][b][c][o][d] => /a/b/c/0/d
   * - dot, a.b.c.0.d => /a/b/c/0/d
   * - json pointer, /a/b/c/0/d => /a/b/c/0/d
   *
   * Conversion of characters is:
   * - `.`. to `/`
   * - `[#]` to `/#/`
   * ` `/` to `/`
   *
   * @public
   * @see f1.lens
   * @function f1.path
   * @param s an object path
   * @example
   *
   * ```ts
   * f1.path('p1.p2') === '/p1/p2'
   * f1.path('p1.p2[2]') === '/p1/p2/2'
   * f1.path('p1[p2]p3') === '/p1/p2/p3'
   * ```
   */
  (path: t_path): t_path;
}

/**
 * @see Path
 */
export default (path: t_path): t_path => {
  return `/${path}`
    .replace(emptyBoxIsDash, '/-/')
    .replace(alternateNotation, '/')
    .replace(duplicateBrackets, '/')
    .replace(removeErrantLastSlash, '');
};
